<template>
    <div class="ece-editor">
        <svg viewBox="-20 -20 140 140">
            <line x1="0" y1="100" x2="100" y2="0" class="ece-reference"></line>
            <rect x="0" y="0" width="100" height="100" class="ece-frame"></rect>

            <line x1="0" y1="100" :x2="p1x" :y2="p1y" class="ece-handle-line"></line>
            <line x1="100" y1="0" :x2="p2x" :y2="p2y" class="ece-handle-line"></line>

            <path :d="curvePath" class="ece-curve"></path>

            <circle cx="0" cy="100" r="3" class="ece-endpoint"></circle>
            <circle cx="100" cy="0" r="3" class="ece-endpoint"></circle>

            <circle :cx="p1x" :cy="p1y" r="6" class="ece-handle" @mousedown.stop.prevent="startDrag(0)"></circle>
            <circle :cx="p2x" :cy="p2y" r="6" class="ece-handle" @mousedown.stop.prevent="startDrag(1)"></circle>
        </svg>
    </div>
</template>

<script>
// Grid area is the 0-0/100-100 square in the middle of the -20..120 viewBox - the surrounding
// padding is only there so a handle dragged into overshoot (see clampY) still has somewhere to
// render instead of getting clipped right at the curve's own start/end frame.
const VIEW_MIN = -20
const VIEW_SIZE = 140
const MIN_Y = -0.3
const MAX_Y = 1.3

export default {
    name: 'EasingCurveEditor',

    props: {
        points: {
            type: Array,
            required: true
        }
    },

    computed: {
        p1x() { return this.points[0] * 100 },
        p1y() { return 100 - this.points[1] * 100 },
        p2x() { return this.points[2] * 100 },
        p2y() { return 100 - this.points[3] * 100 },

        curvePath() {
            return `M0,100 C${this.p1x},${this.p1y} ${this.p2x},${this.p2y} 100,0`
        }
    },

    beforeDestroy() {
        this.stopDrag()
    },

    methods: {
        // index 0 drags the P1 handle (x1/y1 - controls how the transition eases in from its
        // start), index 1 drags P2 (x2/y2 - how it eases into its end). x is clamped to 0-1 (time
        // can't run backward or skip past the transition's own window) - y allows a bit of
        // overshoot past 0-1 for "anticipation/overshoot" style curves, same idea as most bezier
        // editors (devtools' own cubic-bezier picker included).
        startDrag(index) {
            const svg = this.$el.querySelector('svg')

            const onMove = (e) => {
                const rect = svg.getBoundingClientRect()
                const svgX = ((e.clientX - rect.left) / rect.width) * VIEW_SIZE + VIEW_MIN
                const svgY = ((e.clientY - rect.top) / rect.height) * VIEW_SIZE + VIEW_MIN
                const x = Math.min(Math.max(svgX / 100, 0), 1)
                const y = Math.min(Math.max((100 - svgY) / 100, MIN_Y), MAX_Y)

                const next = this.points.slice()
                next[index * 2] = Math.round(x * 100) / 100
                next[index * 2 + 1] = Math.round(y * 100) / 100
                this.$emit('update:points', next)
            }

            document.addEventListener('mousemove', onMove)
            document.addEventListener('mouseup', this.stopDrag)
            this.activeMoveHandler = onMove
        },

        stopDrag() {
            if (!this.activeMoveHandler) return
            document.removeEventListener('mousemove', this.activeMoveHandler)
            document.removeEventListener('mouseup', this.stopDrag)
            this.activeMoveHandler = null
        }
    }
}
</script>

<style lang="scss" scoped></style>
